import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardTitle, Button } from "reactstrap";

const REST_API_DOCS_URL = "https://privapi.movemusic.io";

const RestApi = () => {
  return (
    <Card>
      <CardBody>
        <CardTitle tag="h3">REST API</CardTitle>
        <p>
          Integrate Move Music distribution, catalog management, and reporting
          directly into your own platform with our REST API. Built for labels,
          distributors, and technology partners who need reliable, programmatic
          access to our services.
        </p>
        <p>
          Full API documentation is available at{" "}
          <a
            href={REST_API_DOCS_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {REST_API_DOCS_URL}
          </a>
          . Review the endpoints, authentication requirements, and integration
          guidelines before submitting your application.
        </p>
        <p>
          API access is provided on an approval basis. If you are interested in
          using the REST API, please submit an application and our team will
          review your request. Once approved, we can enable a sandbox environment
          so you can test integrations safely before going live.
        </p>
        <div className="mt-4">
          <Button tag={Link} to="/applications/new" color="success" className="mb-2">
            Apply for REST API
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default RestApi;
